import { render, staticRenderFns } from "./bo-dropdown-search.vue?vue&type=template&id=5b3adcfa"
import script from "./bo-dropdown-search.vue?vue&type=script&lang=js"
export * from "./bo-dropdown-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports